// extracted by mini-css-extract-plugin
export var cancelButton = "_ky-5";
export var content = "_ky-3";
export var createButton = "_ky-6";
export var drawerContainer = "_ky-0";
export var footer = "_ky-2";
export var header = "_ky-1";
export var orderFormColumn = "_ky-4";